// extracted by mini-css-extract-plugin
export default {"list_menu":"index_list_menu_lA1Yu","morehNew":"index_morehNew_45rcj","more":"index_more_RUKC-"};